module.exports = __webpack_public_path__ + "img/forbicicropped.a634b2ce.png";